import script from "./TeacherCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherCard.vue?vue&type=script&setup=true&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=cc11c8f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc11c8f6"]])

export default __exports__